var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"serviceP"},[_c('h2',[_vm._v("服务套餐")]),_vm._v(" "),_c('div',{staticClass:"wrap"}),_vm._v(" "),_c('p',[_vm._v("彩虹律师根据您的需求不同，提供了三个版本，请选择适用您的版本")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.Tocontact}},[_vm._v("立即体验")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14000d00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/serviceP.vue
// module id = null
// module chunks = 